export default {
    list: {
        title: "Container",
        subtitle: "Gestisci i tuoi container",
        newContainer: "Nuovo Container",
        viewMap: "Vedi Mappa",
        loading: "Caricamento container...",
        clearFilters: "Pulisci Filtri",
        backToDashboard: "Torna alla Dashboard",
        filters: {
            searchPlaceholder: "Cerca per numero container, route...",
            statusPlaceholder: "Filtra per stato",
            riskLevelPlaceholder: "Filtra per livello rischio",
            documentStatusPlaceholder: "Filtra per stato documenti",
            docStatusPlaceholder: "Stato Documenti",
            shippingCompanyPlaceholder: "Filtra per compagnia",
            commodityPlaceholder: "Filtra per commodity",
            originPlaceholder: "Filtra per origine",
            portPlaceholder: "Filtra per porto arrivo",
            timeRangePlaceholder: "Periodo",
            allStatuses: "Tutti gli stati",
            allLevels: "Tutti i livelli di rischio",
            allDocStatuses: "Tutti gli stati documenti",
            allCompanies: "Tutte le compagnie",
            allCommodities: "Tutte le commodity",
            allOrigins: "Tutte le origini",
            allPorts: "Tutti i porti",
            docIssuesLabel: "Problemi documenti",
            docIssuesHelper: "Mostra solo i container con problemi sui documenti: documenti mancanti, non conformi o da verificare.",
            docIssuesInfoAria: "Spiega il filtro Problemi documenti",
            activeAlertsLabel: "Alert",
            activeAlertsHelper: "Mostra solo i container con alert attivi: ritardi, temperatura, blocco doganale, ecc.",
            activeAlertsInfoAria: "Spiega il filtro Alert",
        },
        docStatus: {
            pending: "Documenti in Attesa",
            complete: "Documenti Completi",
        },
        timeRange: {
            currentMonth: "Mese corrente",
            lastMonth: "Ultimo mese",
            last3Months: "Ultimi 3 mesi",
            last6Months: "Ultimi 6 mesi",
            last9Months: "Ultimi 9 mesi",
            lastYear: "Ultimo anno",
        },
        table: {
            title: "Container",
            description: "Lista completa dei container",
            updating: "Aggiornamento...",
            headers: {
                containerNumber: "Riferimento Container",
                route: "Route",
                progress: "Progresso",
                status: "Stato",
                documentStatus: "Documenti",
                riskLevel: "Rischio",
                value: "Valore",
                createdAt: "Creato",
                actions: "Azioni",
                carrier: "Vettore",
                receiver: "Destinatario",
                etd: "ETD",
                eta: "ETA",
                documents: "Documenti",
                docStatus: "Stato Doc",
                extraDocIssues: "Problemi Extra-Doc",
                lastUpdate: "Ultimo Aggiornamento",
                bookingNo: "N. Booking",
                blNo: "N. B/L",
                valueUsd: "Valore (USD)",
                product: "Prodotto",
                qtyWeight: "Qtà/Peso",
                tempC: "Temp (°C)",
                actualTd: "Partenza Eff.",
                delayDays: "Giorni Ritardo",
                originPort: "Porto Origine",
                destPort: "Porto Dest.",
                paymentTerms: "Termini Pagamento",
                freightTerms: "Termini Trasporto",
            },
            view: "Visualizza",
            edit: "Modifica",
            delete: "Elimina",
            noContainers: {
                title: "Nessun container trovato",
                message: "Prova a modificare i filtri di ricerca",
                emptyMessage: "Inizia creando il tuo primo container",
                createFirst: "Crea il primo container",
            },
        },
        charts: {
            riskLevels: "Livello di Rischio",
            containerStatus: "Stato Container",
            documentStatus: "Stato Parsing Documenti",
        },
        spreadsheet: {
            noDocuments: "Nessun documento",
            allDocsOk: "Documenti OK",
            issuesInDocs: "{{count}} problemi nei documenti",
            noIssues: "Nessun problema",
            issueCount: "{{count}} problemi",
            comingSoon: "Prossimamente",
            fewerColumns: "Meno colonne",
            moreColumns: "Più colonne",
            export: "Esporta",
            excelXlsx: "Excel (.xlsx)",
            csvFile: "CSV (.csv)",
            ofTotal: "{{current}} di {{total}}",
        },
        expandedDetails: {
            hideDetails: "Nascondi dettagli",
            bookingNumber: "Numero Booking",
            poNumber: "Numero PO",
            vessel: "Nave",
            voyage: "Viaggio",
            consignee: "Consegnatario",
            incoterms: "Incoterms",
            transportMode: "Modalità Trasporto",
            cargoType: "Tipo Carico",
            hazardousMaterial: "Materiale Pericoloso",
            hazardousYes: "Sì ({{hazClass}})",
            hazardousNo: "No",
            weightKg: "Peso (kg)",
            volumeCbm: "Volume (cbm)",
            packages: "Colli",
            totalValue: "Valore Totale",
            freightCost: "Costi Trasporto",
            insurance: "Assicurazione",
            hsCode: "Codice HS",
            progress: "Progresso",
            bookingDate: "Data Prenotazione",
            departure: "Partenza",
            created: "Creato",
            documentStatus: "Stato Documenti",
            systemStatus: "Stato Sistema",
            trackingProvider: "Provider Tracking",
            lastTracked: "Ultimo Tracking",
            activeAlerts: "Alert Attivi",
            alertsYes: "Sì ({{count}})",
            alertsNo: "No",
            temperature: "Temperatura",
            viewEmails: "Vedi email",
            viewDocuments: "Vedi documenti",
        },
    },
    form: {
        title: "Nuovo Container",
        editTitle: "Modifica Container",
        subtitle: "Crea un nuovo container",
        editSubtitle: "Modifica i dettagli del container",
        loading: "Caricamento container...",
        back: "Indietro",
        sections: {
            containerInfo: "Informazioni Container",
            route: "Rotta",
            order: "Ordine",
            receiver: "Ricevitore",
            value: "Valore",
            vesselInfo: "Nave & Prenotazione",
        },
        fields: {
            bookingNumber: "Numero Prenotazione",
            bookingNumberPlaceholder: "EVE2025-001234",
            containerNumber: "Container Number",
            containerNumberPlaceholder: "MAEU1234567",
            blNumber: "Bill of Lading",
            blNumberPlaceholder: "BL123456789",
            status: "Status",
            statusPlaceholder: "Seleziona status",
            physicalStatus: "Stato Fisico",
            physicalStatusPlaceholder: "Seleziona stato fisico",
            routeFrom: "Da",
            routeFromPlaceholder: "New York, USA",
            routeTo: "A",
            routeToPlaceholder: "London, UK",
            eta: "ETA",
            shippingCompany: "Compagnia di Shipping",
            shippingCompanyPlaceholder: "Seleziona compagnia",
            receiver: "Receiver",
            receiverPlaceholder: "Seleziona receiver",
            amount: "Importo",
            amountPlaceholder: "125000",
            currency: "Valuta",
            currencyPlaceholder: "Seleziona valuta",
            orderId: "Order ID",
            orderIdPlaceholder: "Inserisci o seleziona Order ID",
            orderIdSelectExisting: "Seleziona da ordini esistenti",
            orderIdEnterManually: "Inserisci manualmente",
            vesselName: "Nome Nave",
            vesselNamePlaceholder: "Inserisci nome nave",
            voyageNumber: "Numero Viaggio",
            voyageNumberPlaceholder: "Inserisci numero viaggio",
        },
        actions: {
            cancel: "Annulla",
            save: "Salva Modifiche",
            create: "Crea Container",
        },
        errors: {
            generic: "Si è verificato un errore durante il salvataggio del container",
            allFieldsRequired: "Tutti i campi sono obbligatori",
            amountInvalid: "L'importo deve essere un numero maggiore di 0",
            containerExists: "Un container con questo numero esiste già",
            containerNumberRequired: "Il numero del container è obbligatorio",
            bookingNumberRequired: "Il numero di prenotazione è obbligatorio",
        },
        updateSuccess: "Container aggiornato con successo",
        updateError: "Errore durante l'aggiornamento del container",
        loadError: "Errore durante il caricamento del container",
        backToList: "Torna ai Container",
        containerNumberReadonly: "Il numero del container non può essere modificato",
        bookingNumberReadonly: "Il numero di prenotazione non può essere modificato",
        bookingNumberHint: "Numero di riferimento prenotazione del vettore",
        containerNumberHint: "Numero container ISO (opzionale - assegnato dal vettore)",
        blNumberHint: "Necessario per il tracciamento del vettore",
        noReceivers: "Nessun receiver attivo disponibile. Invita un nuovo receiver per continuare.",
        selectReceiver: "Seleziona Receiver",
        notesOptional: "Note (opzionale)",
        notesPlaceholder: "Aggiungi una nota per il receiver...",
        selectedReceiver: "Receiver Selezionato",
        name: "Nome",
        email: "Email",
        country: "Paese",
        sendInvite: "Invia Invito",
    },
    detail: {
        back: "Torna ai Container",
        backToList: "Torna alla lista",
        loading: "Caricamento dettagli container...",
        notFound: {
            title: "Container non trovato",
            message: "Il container richiesto non esiste o non hai i permessi per visualizzarlo.",
        },
        actions: {
            uploadDocuments: "Carica Documenti",
            triage: "Triage",
            edit: "Modifica",
            share: "Condividi",
            archive: "Archivia",
            delete: "Elimina",
            actions: "Azioni",
            availableActions: "Azioni Disponibili",
            comingSoon: "Prossimamente",
            addNote: "Aggiungi Nota",
            addNoteDesc: "Aggiungi note interne o per il cliente",
            evaluateDocs: "Valuta Documenti",
            evaluateDocsDesc: "Controllo incrociato AI per discrepanze",
            refreshTracking: "Aggiorna Tracking",
            reportIssue: "Segnala Problema",
            reportIssueDesc: "Segnala un problema con questo container",
            viewRisk: "Valutazione Rischio",
            viewRiskDesc: "Visualizza analisi rischio dettagliata",
            noRiskData: "Dati di Rischio Non Disponibili",
            noRiskDataDesc: "I dati di valutazione del rischio non sono ancora disponibili per questo container. Verranno calcolati quando ci saranno attività o problemi da analizzare.",
            noDocumentsToEvaluate: "Nessun Documento Disponibile",
            noDocumentsToEvaluateDesc: "Carica almeno 2 documenti in questo container per abilitare la validazione incrociata.",
            needMoreDocs: "Servono almeno 2 documenti",
            prepareClaim: "Prepara Reclamo",
            insuranceQuote: "Richiedi Preventivo Assicurazione",
            searchIssues: "Cerca Problemi Passati",
            makeRecurring: "Rendi Ricorrente",
            duplicate: "Duplica Container",
        },
        confirmDeleteContainer: {
            title: "Elimina Permanentemente Container",
            message: "Sei sicuro di voler eliminare permanentemente il container {{containerNumber}}? Questa azione NON PUÒ essere annullata.",
            warning: "ATTENZIONE: Questa azione è IRREVERSIBILE. Il container e TUTTI i dati correlati verranno eliminati definitivamente: documenti, eventi, problemi, note, ordini, email e storico tracking.",
            typeDeleteLabel: "Digita DELETE per confermare:",
            cancel: "Annulla",
            delete: "Elimina Definitivamente",
            success: "Il container {{containerNumber}} è stato eliminato definitivamente.",
            error: "Impossibile eliminare il container. Riprova.",
        },
        confirmArchiveContainer: {
            title: "Archivia Container",
            message: "Sei sicuro di voler archiviare il container {{containerNumber}}?",
            warning: "Il container verrà nascosto dalla lista ma tutti i dati verranno conservati. Potrai ripristinarlo in seguito.",
            typeArchiveLabel: "Digita ARCHIVE per confermare:",
            cancel: "Annulla",
            archive: "Archivia Container",
            success: "Il container {{containerNumber}} è stato archiviato con successo.",
            error: "Impossibile archiviare il container. Riprova.",
        },
        tabs: {
            overview: "Panoramica",
            info: "Informazioni",
            documents: "Documenti",
            timeline: "Timeline",
            notes: "Note",
            issues: "Issues",
            more: "Altro",
            moreHint: "timeline e note",
        },
        info: {
            containerInfo: "Informazioni Container",
            route: "Route",
            shipper: "Spedizioniere",
            receiver: "Receiver",
            from: "Da",
            to: "A",
            created: "Creato",
            expandMap: "Espandi mappa",
            collapseMap: "Riduci mappa",
            lastUpdate: "Ultimo aggiornamento",
            transportDetails: "Dettagli Trasporto e Carico",
            notes: "Note e Istruzioni",
            sections: {
                vessel: "Nave",
                container: "Container",
                cargo: "Carico",
                references: "Riferimenti",
                primaryParties: "Parti Principali",
                otherParties: "Altre Parti (dai documenti)",
                shipmentSteps: "Avanzamento Spedizione",
                quickContacts: "Contatti Rapidi",
            },
            stakeholders: "Aziende Coinvolte",
            badges: {
                hazardous: "Pericoloso",
                reefer: "Reefer",
            },
            phaseTimeline: {
                title: "Stato della spedizione",
                phases: {
                    draft: "Bozza",
                    booked: "Prenotato",
                    in_transit: "In transito",
                    arrived: "Arrivato",
                    delivered: "Consegnato",
                },
                activeDesc: {
                    draft: "Container creato",
                    booked: "Prenotazione confermata con il vettore",
                    inTransit: "Spedizione in transito",
                    arrived: "Arrivato a destinazione",
                    delivered: "Consegnato al destinatario",
                },
                stepsCount: "{{count}} passi",
                by: "Da",
                subSteps: {
                    draft: "Bozza",
                    draftDesc: "Container creato",
                    bookingConfirmed: "Prenotazione confermata",
                    bookingConfirmedDesc: "Prenotazione spedizione confermata con il vettore",
                    documentsReady: "Documenti pronti",
                    documentsReadyDesc: "Documenti richiesti inviati o collegati",
                    vesselDeparted: "Nave partita",
                    vesselDepartedDesc: "Nave salpata dal porto di origine",
                    inTransit: "In transito",
                    inTransitDesc: "Spedizione in viaggio verso destinazione",
                    arrivedAtPort: "Arrivato in porto",
                    arrivedAtPortDesc: "Nave arrivata al porto di destinazione",
                    customsClearance: "Sdoganamento",
                    customsClearanceDesc: "Sdoganamento in corso o completato",
                    deliveryConfirmed: "Consegna confermata",
                    deliveryConfirmedDesc: "Carico ricevuto e confermato dal destinatario",
                },
            },
            fields: {
                status: "Status",
                progress: "Progress",
                riskLevel: "Risk Level",
                documentStatus: "Doc Status",
                eta: "ETA",
                value: "Valore",
                shippingCompany: "Spedizioniere",
                country: "Paese",
                lastTracked: "Ultimo tracking",
                activeIssues: "Problemi Attivi",
                vesselName: "Nome Nave",
                voyageNumber: "Numero Viaggio",
                carrier: "Vettore",
                receiver: "Destinatario",
                containerType: "Tipo Container",
                cargoType: "Tipo Carico",
                transportMode: "Modalità Trasporto",
                incoterms: "Incoterms",
                description: "Descrizione",
                hsCode: "Codice HS",
                weight: "Peso",
                volume: "Volume",
                packages: "Colli",
                bookingNumber: "N. Booking",
                blNumber: "N. BL",
                purchaseOrder: "N. Ordine",
                serviceContract: "Contratto Servizio",
                etd: "ETD",
                atd: "ATD",
                ata: "ATA",
                specialInstructions: "Istruzioni Speciali",
                customerNotes: "Note Cliente",
                consigneeId: "ID Destinatario",
            },
        },
        tracking: {
            lastJsonCargoUpdate: "Aggiornamento JSONCargo",
            noJsonCargoUpdate: "Nessun aggiornamento JSONCargo",
            lastEmailUpdate: "Aggiornamento email",
            noEmailUpdate: "Nessun aggiornamento email",
            createdFromEmail: "Creato da email importata",
            setCarrierManually: "Imposta il carrier manualmente",
            carrierSelectPlaceholder: "Seleziona carrier…",
            setCarrierConfirm: "Imposta carrier",
            carrierSetSuccess: "Carrier impostato — tracking aggiornato",
            carrierSetError: "Impossibile aggiornare il tracking",
        },
        documents: {
            title: "Documenti",
            headers: {
                name: "Nome",
                type: "Tipo",
                status: "Status",
                uploaded: "Uploaded",
                actions: "Azioni",
            },
            actions: {
                view: "Visualizza",
                review: "Revisione",
                history: "Storico",
                download: "Download",
                delete: "Elimina",
            },
            confirmDelete: {
                title: "Elimina Documento",
                message: "Sei sicuro di voler eliminare questo documento? Questa azione non può essere annullata.",
                cancel: "Annulla",
                delete: "Elimina",
            },
            uploadInDevelopment: "Funzionalità di caricamento documenti in sviluppo",
            uploadDocument: "Carica Documento",
            discrepancies: {
                allCongruent: {
                    title: "Tutti i documenti sono congruenti",
                    message: "Le discrepanze sono state risolte con successo. Tutti gli attributi estratti dai documenti sono ora allineati e verificati.",
                    resetButton: "Reset discrepanze",
                    viewTriage: "Visualizza Triage",
                },
                detected: {
                    title: "Possibili discrepanze nei dati dei documenti",
                    message:
                        "Abbiamo rilevato incongruenze tra alcuni attributi estratti dai documenti di questo container. Ti consigliamo di procedere con il triage per verificarli e correggerli.",
                    goToTriage: "Vai al Triage Documenti",
                },
            },
        },
        timeline: {
            title: "Timeline Eventi",
            events: {
                containerCreated: "Container creato",
                statusChanged: "Status cambiato",
                documentsUploaded: "Documenti caricati",
                progressUpdated: "Progress aggiornato",
            },
            statusChangedFrom: "Status cambiato da",
            to: "a",
            documentsUploadedCount: "documenti caricati",
            progressUpdatedTo: "Progress aggiornato al",
        },
        notes: {
            acknowledged: "Preso in carico",
            resolved: "Risolto",
            dismissed: "Archiviato",
            wontFix: "Non verrà corretto",
            inProgress: "In corso",
            pendingInfo: "In attesa di info",
            opened: "Aperto",
            actionsTab: "Azioni",
            noActionsYet: "Nessuna azione ancora",
            noActionsDesc: "Le valutazioni documenti e le azioni sui problemi appariranno qui",
            documentAnalysis: "Analisi Documenti",
            allClear: "Tutto ok",
            viewResults: "Vedi Risultati",
            findingsCount: "{{count}} segnalazioni",
            issuesCount: "{{count}} problemi",
            edited: "modificata",
        },
        evaluation: {
            stepReExtraction: "Ri-estrazione in corso\u2026",
            stepRequiredDocs: "Verifica documenti richiesti\u2026",
            stepCrossRules: "Controllo incrociato regole\u2026",
            stepAiAnalysis: "Analisi incrociata AI\u2026",
            selectedOf: "{{selected}} di {{total}} selezionati",
            willCheck: "Verificherà: documenti mancanti \u00b7 regole incrociate \u00b7 analisi AI",
            requiredDocuments: "Documenti Richiesti",
            allRequiredPresent: "Tutti i documenti richiesti presenti",
            missing: "mancante",
            crossCheckResults: "Risultati Cross-Check",
            crossChecksPassed: "Tutti i {{count}} cross-check superati",
            passedAndFailed: "{{passed}} superati \u00b7 {{failed}} falliti",
            aiObservations: "Osservazioni AI",
            noDiscrepancies: "Nessuna discrepanza trovata",
            noData: "Nessun dato",
        },
    },
    triage: {
        title: "Triage Documenti",
        subtitle: "Container",
        resolveWithAI: "Risolvi con AI",
        tabs: {
            matrix: "Matrice",
            visual: "Visual",
            raw: "Raw Data",
        },
        matrix: {
            attribute: "Attributo",
            ok: "OK",
            ko: "KO",
        },
        visual: {
            document: "Documento",
            check: "Check",
            ok: "OK",
        },
        raw: {
            json: "JSON",
            highlightDiscrepancies: "Highlight discrepanze",
        },
        modal: {
            title: "Risoluzione discrepanze con AI",
            analyzing: "Sto analizzando e correggendo gli attributi estratti…",
            completed: "Risoluzione completata",
            allResolved: "Tutte le discrepanze sono state risolte. Puoi chiudere questa finestra per vedere i risultati aggiornati.",
            close: "Chiudi",
        },
    },
    upload: {
        title: "Carica Documenti",
        subtitle: "Carica documenti per il container",
        loading: "Caricamento...",
        notFound: {
            title: "Container non trovato",
            message: "Il container richiesto non esiste.",
            backToList: "Torna alla lista",
        },
        fileTooLarge: "File {fileName} è troppo grande. Massimo 10MB consentiti.",
        selectAtLeastOne: "Seleziona almeno un file da caricare",
        documentType: "Tipo Documento",
        uploadSelected: "Carica Selezionati",
        cancel: "Annulla",
        confirmUpload: "Conferma Caricamento",
        uploadInProgress: "Caricamento in corso",
        uploadCompleted: "Caricamento completato",
        returnToDocuments: "Torna ai Documenti",
        removeFile: "Rimuovi file",
        selectFiles: "Seleziona File",
        selectedFiles: "File Selezionati",
        file: "file",
        files: "file",
        document: "documento",
        documents: "documenti",
        container: "Container",
        uploading: "Caricamento...",
        uploadedSuccessfully: "Caricato con successo",
        documentsUploadedSuccess: "Documenti caricati con successo!",
        documentsNowAvailable: "documento(i) sono stati caricati e sono ora disponibili nella sezione Documenti.",
        goToDocuments: "Vai ai Documenti",
        confirmUploadTitle: "Conferma Upload Documenti",
        unknownTypeWarning:
            'Alcuni documenti hanno tipo "Unknown Document". Questo significa che il sistema non è riuscito a identificare automaticamente il tipo di documento.',
        unknownTypeDocuments: "Documenti con tipo Unknown:",
        proceedAnyway: "Puoi procedere comunque con l'upload. I documenti potranno essere classificati manualmente in seguito.",
        proceedWithUpload: "Procedi con Upload",
    },
    worldMap: {
        title: "Live Tracking Hub",
        backToList: "Torna alla lista",
        updateInfo: "Il sistema controlla e aggiorna la posizione dei container periodicamente.",
        lastUpdate: "Ultimo aggiornamento",
        containerDetails: "Dettagli Container",
        viewFullDetails: "Vedi dettagli completi",
        showContainers: "Mostra Container",
        showDetails: "Mostra dettagli",
        hideToSeeRoute: "Nascondi per vedere la rotta",
        containerList: "Container nella Mappa",
        containerSingular: "container",
        containerPlural: "container",
        filterInProgress: "In transito",
        filterDelivered: "Arrivati",
        filterAll: "Tutti",
        lastKnownCoordinates: "Ultime coordinate note",
        positionRecordedAt: "Registrate: {{time}}",
        routeOrigin: "Partenza (porto di origine)",
        routeDestination: "Arrivo (porto di destinazione)",
        shipmentCarrier: "Vettore",
        shipmentVesselVoyage: "Nave · Viaggio",
        shipmentCargo: "Merce",
        positionFixAt: "Fix posizione: {{time}}",
        aisLabel: "AIS",
        aisSpeedKn: "{{value}} kn",
        aisImo: "IMO {{imo}}",
        aisMmsi: "MMSI {{mmsi}}",
        aisCourse: "{{deg}}°",
        aisHeading: "Prua {{deg}}°",
        aisDestination: "Destinazione AIS: {{dest}}",
        aisEta: "ETA AIS: {{eta}}",
        sectionShipment: "Dettagli spedizione",
        sectionPosition: "Posizione e AIS",
    },
    receiver: {
        title: "Container Ricevuti",
        subtitle: "Gestisci i container ricevuti dagli spedizionieri",
        loading: "Caricamento container...",
        searchPlaceholder: "Cerca per container ID, route o spedizioniere...",
        shipperPlaceholder: "Filtra per spedizioniere",
        allShippers: "Tutti gli spedizionieri",
        description: "Lista completa dei container ricevuti",
        headers: {
            containerId: "Rif. Container",
            shipper: "Spedizioniere",
            route: "Route",
            shippingCompany: "Spedizioniere",
            progress: "Progress",
            eta: "ETA",
            status: "Status",
            docStatus: "Doc Status",
            riskLevel: "Risk Level",
            value: "Valore",
            actions: "Azioni",
        },
        noContainers: {
            title: "Nessun container trovato",
            message: "Prova a modificare i filtri di ricerca",
            emptyMessage: "Nessun container ricevuto ancora",
        },
        viewDetails: "Visualizza Dettagli",
        shipper: "Spedizioniere",
    },
};
